import React from 'react';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { history } from '../../utilities/getSearchParams';

const CustomRouter = ({ children, ...props }) => {
  return (
    <HistoryRouter history={history} {...props}>
      {children}
    </HistoryRouter>
  );
};

export default CustomRouter;
